import {ErrorModel} from '../_models/error.model';
import {Injectable} from '@angular/core';
import {throwError as observableThrowError, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  public Error: ErrorModel;

  public handleError(error: any): Observable<any> {

    this.Error = {errCode: 0, errMessage: ''};

    // FUNCTION TO TEST JSON
    const testingJSON = () => {
      let item = {};
      try {
        item = error.json();
      } catch (e) {
        return false;
      }
      return typeof item === 'object' && item !== null;
    };

    const iterateObj = (sourceObj: any) => {
      if (sourceObj instanceof Object) {
        for (const key in sourceObj) {
          if (sourceObj.hasOwnProperty(key)) {
            iterateObj(sourceObj[key]);
          }
        }
      } else {
        this.Error.errMessage = sourceObj;
      }
    };

    if (error.error?.innerException?.Message) {
      this.Error.errCode = 9999;
      this.Error.errMessage = error.error.innerException.Message;
    } else if (error.message || error.stack) {
      this.Error.errCode = error.status || 9999;
      if (error.error && !Array.isArray(error.error) && !(error.error instanceof ProgressEvent)) {
        this.Error.errMessage = error.error.message || error.error.detail || error.error;
      } else if (error.error && Array.isArray(error.error) && error.error.length > 0) {
        const tempErrs = [];
        for (const curErr of error.error) {
          if (curErr.errors && curErr.errors.length > 0) {
            // SPECIFIC MARKET ACCESS API ERROR
            for (const curErrDetail of curErr.errors) {
              tempErrs.push(curErrDetail);
            }
          } else if (curErr.name && curErr.id && curErr.description && curErr.name.toLowerCase() !== 'success') {
            // SPECIFIC P2G ERROR
            tempErrs.push(curErr.id + ': ' + curErr.description);
          }
        }
        this.Error.errMessage = tempErrs;
      } else {
        this.Error.errMessage = error.message;
      }
    } else if (!error.status || error.status === 0) {
      // NO INFO IN THE RESPONSE, THROW GENERIC ERROR
      this.Error.errCode = 9999;
      this.Error.errMessage = 'Server failed to respond in time';
    } else if (error.status && error._body && testingJSON()) {
      // RESPONSE WITH VALID JSON BODY
      this.Error.errCode = error.status;
      const tmpErrMsg: any = error.json();
      // IGNORE INTERMEDIATE OBJECTS AND GO DOWN TO LOWEST LEVEL (STRING)
      iterateObj(tmpErrMsg);
    } else if (error.status) {
      // RESPONSE WITHOUT VALID BODY
      this.Error.errCode = error.status;
      if (error.statusText) {
        this.Error.errMessage = error.statusText;
      } else {
        this.Error.errMessage = 'Request ended with status ' + error.status;
      }
    } else {
      // THIS SHOULD NEVER HAPPEN, IF SO, AN EXTRA BLOCK SHOULD BE ADDED ABOVE
      this.Error.errCode = 9999;
      this.Error.errMessage = error.toString();
    }
    // RETURN OBSERVABLE
    return observableThrowError(this.Error);
  }

}
